import axios from 'axios'
import {AuthModel, UserModel} from './_models'
import {ResponseType} from '../../../core/_models'

const API_URL = process.env.REACT_APP_BASE_API_URL

export const LOGIN_URL = `${API_URL}/auth/signin`
export const REGISTER_URL = `${API_URL}/auth/signup`
export const VERIFY_REGISTER_URL = `${API_URL}/auth/verify-register`
export const RESET_PASSWORD_URL = `${API_URL}/auth/reset`
export const FORGOT_PASSWORD = `${API_URL}/auth/forgot`
export const SOCIAL_LOGIN_VARIFICATION = `${API_URL}/auth/social-signin`
export const INVITE_USER = `${API_URL}/auth/invite`
export const ACCEPT_INVITATION = `${API_URL}/auth/accept-invite`
export const CREATE_COMPANY = `${API_URL}/company`
export const CREATE_ROUND = `${API_URL}/round`
export const CURRENCIES = `${API_URL}/currency`
export const GET_USER_BY_ACCESSTOKEN_URL = `${API_URL}/auth/verify-token`
export const VERIFY_TOKEN = `${API_URL}/auth/verify-token`
export const VERIFY_INVITE = `${API_URL}/auth/verify-invite`
export const ACCEPT_INVITE = `${API_URL}/auth/accept-invite`
export const ACCEPT_RECEIVED_INVITE = `${API_URL}/auth/accept-received-invite`

const VERIFY_RESET_LINK = `${API_URL}/auth/reset/verify`
const RESEND_VERIFICATION = `${API_URL}/auth/resend-verification`
const REFRESH_TOKEN = `${API_URL}/auth/refresh-token`
const SETUP_2FA = `${API_URL}/auth/setup-2fa`
const VERIFY_SETUP_2FA = `${API_URL}/auth/verify-setup-2fa`
const BACKUP_CODES = `${API_URL}/backup-codes`
const GET_2FA_DETAILS = `${API_URL}/twoFa-details`
const VERIFY_2FA = `${API_URL}/auth/verify-2fa`
const DISCONNECT_2FA = `${API_URL}/auth/disconnect-2fa`

// export const REQUEST_PASSWORD_URL = `${API_URL}/forgot_password`

// Server should return AuthModel
//signin
export function login(email: string, password: string) {
  return axios.post<ResponseType<AuthModel>>(
    LOGIN_URL,
    {
      email,
      password,
    },
    {
      validateStatus(status) {
        return true
      },
    }
  )
}

//signup

export function register(userId: number | undefined, otp: string) {
  return axios.post(
    REGISTER_URL,
    {userId, otp},
    {
      validateStatus(status) {
        return true
      },
    }
  )
}

// verify-sigup
export function verifyRegister(
  email: string,
  firstname: string,
  lastname: string,
  password: string,
  utm_source: string,
  utm_medium: string,
  utm_campaign: string,
  utm_content: string,
  utm_term: string,
  gclid: string,
  referral: string,
  locale: string,
  dateFormat: string,
  timeFormat: string,
  timeZone: string,
  countryCode: string,
  stateCode: string,
  city: string,
  zipCode: number,
  signUpCompany: string,
  fprom_tid: string,
  fprom_ref: string
) {
  return axios.post(
    VERIFY_REGISTER_URL,
    {
      email,
      firstName: firstname,
      lastName: lastname,
      password,
      utm_source,
      utm_medium,
      utm_campaign,
      utm_content,
      utm_term,
      gclid,
      referral,
      locale,
      dateFormat,
      timeFormat,
      timeZone,
      countryCode,
      stateCode,
      city,
      zipCode,
      signUpCompany,
      fprom_tid,
      fprom_ref,
    },
    {
      validateStatus(status) {
        return true
      },
    }
  )
}

//reset password
export function resetPassword(token: string, password: string) {
  return axios.patch(
    RESET_PASSWORD_URL,
    {
      token,
      password,
    },
    {
      validateStatus(status) {
        return true
      },
    }
  )
}

//forgot password
export function forgotPassword(email: string) {
  return axios.post(
    FORGOT_PASSWORD,
    {email},
    {
      validateStatus(status) {
        return true
      },
    }
  )
}

//social login varification
export function socialLoginVerification(type: string, token: string) {
  return axios.post(SOCIAL_LOGIN_VARIFICATION, {type, token})
}

// Server should return object => { result: boolean } (Is Email in DB)
// export function requestPassword(email: string) {
//   return axios.post<{result: boolean}>(REQUEST_PASSWORD_URL, {
//     email,
//   })
// }

export function getUserByToken(token: string) {
  return axios.post<ResponseType<UserModel>>(GET_USER_BY_ACCESSTOKEN_URL, {
    token,
  })
}

export function verifyToken(token: string) {
  localStorage.setItem('kt-auth-react-v', JSON.stringify({token}))
  return axios.post(VERIFY_TOKEN, {token})
}

export function verifyInvite(inviteToken: string) {
  return axios.post(
    VERIFY_INVITE,
    {inviteToken},
    {
      validateStatus(status) {
        return true
      },
    }
  )
}

export function acceptInvite(
  inviteToken: string,
  password: string,
  locale: string,
  dateFormat: string,
  timeFormat: string,
  timeZone: string
) {
  return axios.post(ACCEPT_INVITE, {
    inviteToken,
    password,
    locale,
    dateFormat,
    timeFormat,
    timeZone,
  })
}

export const getTokenStatus = (token: string) => {
  return axios.post(VERIFY_RESET_LINK, {token})
}

export const resendVerification = (payload: {email: string}) => {
  return axios.post(RESEND_VERIFICATION, payload, {
    validateStatus(status) {
      return true
    },
  })
}

export const refreshTokenApi = () => {
  return axios.get(REFRESH_TOKEN, {
    validateStatus(status) {
      return true
    },
  })
}

export const setup2FA = () => {
  return axios.post(
    SETUP_2FA,
    {},
    {
      validateStatus(status) {
        return true
      },
    }
  )
}

export const verifySetup2FA = (otp: string) => {
  return axios.post(
    VERIFY_SETUP_2FA,
    {otp},
    {
      validateStatus(status) {
        return true
      },
    }
  )
}

export const downloadBackupCodes = () => {
  return axios.get(BACKUP_CODES, {
    validateStatus(status) {
      return true
    },
  })
}

export const get2FaDetails = () => {
  return axios.get(GET_2FA_DETAILS, {
    validateStatus(status) {
      return true
    },
  })
}

export const verify2FA = (otp: string, token: string) => {
  return axios.post(
    VERIFY_2FA,
    {otp, token},
    {
      validateStatus(status) {
        return true
      },
    }
  )
}

export const disconnect2Fa = () => {
  return axios.post(
    DISCONNECT_2FA,
    {},
    {
      validateStatus(status) {
        return true
      },
    }
  )
}

export function acceptReceivedInvite(inviteId: number) {
  return axios.post(
    ACCEPT_RECEIVED_INVITE,
    {inviteId},
    {
      validateStatus(status) {
        return true
      },
    }
  )
}
